import React from "react";
type BracketButtonProps = {
  href?: string;
  children: React.ReactNode;
  variant?: "brand" | "light";
  type?: "button" | "submit";
  disabled?: boolean;
  className?: string;
};
export function BracketButton({
  href,
  children,
  variant = "brand",
  type = "button",
  disabled,
  className = ""
}: BracketButtonProps) {
  const inner = variant === "brand" ? "bg-brand text-white group-hover:bg-brand-deep" : "bg-white text-ink group-hover:bg-paper-line";
  const content = <>
      <Corner className="left-0 top-0 border-l border-t" data-id="element-34" data-mp="d6jkawyap7xf" />
      <Corner className="right-0 top-0 border-r border-t" data-id="element-35" data-mp="d4yvlnynwj7h" />
      <Corner className="bottom-0 left-0 border-b border-l" data-id="element-36" data-mp="86ow515wmwg2" />
      <Corner className="bottom-0 right-0 border-b border-r" data-id="element-37" data-mp="395hw197ijo4" />
      <span className={`flex items-center justify-center gap-2 whitespace-nowrap px-6 py-3.5 text-[13px] font-semibold uppercase tracking-[0.08em] transition-colors duration-150 ease-out ${inner}`} data-id="element-38" data-mp="38nfsnzv5b8a">
        {children}
      </span>
    </>;
  const cls = `group relative inline-flex p-1.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand disabled:cursor-not-allowed disabled:opacity-60 ${className}`;
  if (href) {
    return <a href={href} className={cls} data-id="element-39" data-mp="2sancvhdrijjg">
        {content}
      </a>;
  }
  return <button type={type} disabled={disabled} className={cls} data-id="element-40" data-mp="2x62os3s7m5d8">
      {content}
    </button>;
}
function Corner({
  className
}: {
  className: string;
}) {
  return <span aria-hidden="true" className={`absolute h-2.5 w-2.5 border-ink/40 transition-transform duration-150 ease-out group-hover:scale-110 ${className}`} data-id="element-41" data-mp="2n9pvv84hnvjj" />;
}